import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IReportConfigEntry } from '../custom_text_interface';
import { ApptSummaryConfigModel } from '../models/appt_summary_config_model';
import { HandRaiseConfigModel } from '../models/hand_raise_config_model';
import { NotesConfigModel } from '../models/notes_config_model';
import { ProgressReportsConfigModel } from '../models/progress_reports_config_model';

export class ReportConfigsQuery implements IQuery {
  private _result: IReportConfigEntry[];

  constructor(
    private ngApptSummaryConfigModel: ApptSummaryConfigModel,
    private ngHandRaiseConfigModel: HandRaiseConfigModel,
    private ngNotesConfigModel: NotesConfigModel,
    private ngProgressReportsConfigModel: ProgressReportsConfigModel
  ) {
    Query.registerQuery(
      this,
      ngApptSummaryConfigModel,
      ngHandRaiseConfigModel,
      ngNotesConfigModel,
      ngProgressReportsConfigModel
    );
  }

  run(): ReportConfigsQuery {
    const apptSummaryConfig = this.ngApptSummaryConfigModel.read();
    const handRaiseConfig = this.ngHandRaiseConfigModel.read();
    const notesConfig = this.ngNotesConfigModel.read();
    const progressReportsConfig = this.ngProgressReportsConfigModel.read();

    //assuming the feature toggle boolean from appconfig is identical to command api call enabled attribute
    this._result = [apptSummaryConfig, handRaiseConfig, notesConfig, progressReportsConfig];
    localStorage.setItem('eab.navigate.report_config', JSON.stringify(this._result));
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('data-ng-custom-text').service('ngReportConfigsQuery', ReportConfigsQuery);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/queries/report_configs_query.ts